/* eslint-disable @typescript-eslint/naming-convention */
export enum SiteAlertState {
  NoIssues = 'NO_ISSUES',
  Alerts = 'ALERTS',
  Issues = 'ISSUES',
}

export enum BessStatus {
  Faulty = 'FAULTY',
  Performing = 'PERFORMING',
}

export enum SiteReadinessState {
  Ready = 'READY',
  UnderCommissioning = 'UNDER_COMMISSIONING',
}

export enum ChargerOperationalStatus {
  Operational = 'OPERATIONAL',
  Maintenance = 'MAINTENANCE',
  Faulted = 'FAULTED',
  Offline = 'OFFLINE',
}

export enum ChargerStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}
